export const INTERNAL_TYPES = {
  connect: 'connect',
  connected: 'connected',
};

export const LIB_ID = '@wikia/post-quecast';
